import React, { useState } from "react";
import emailjs from "emailjs-com";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import DefaultNavbar from "parts/Navbars/DefaultNavbar";
import DefaultFooter from "parts/Footers/DefaultFooter";
import routes from "routes";
import footerRoutes from "footer.routes";
import bgImage from "assets/images/contact.jpg";

import { Helmet } from 'react-helmet';
function ContactUs() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_i828gpe", // Replace with your EmailJS service ID
        "template_dxo7e4g", // Replace with your EmailJS template ID
        formData,
        "1h2y1hKfCURmuO3Va" // Replace with your EmailJS public key
      )
      .then(
        () => {
          setDialogMessage("Message sent successfully!");
          setDialogOpen(true);
        },
        () => {
          setDialogMessage("Failed to send message. Please try again later.");
          setDialogOpen(true);
        }
      );
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
        <Helmet>
        <title>Contact Us - HPTech Solutions</title>
        <meta name="description" content="Get in touch with HPTech Solutions for AI, Cyber Security, Web Development, and other tech solutions. We're here to help your business grow with cutting-edge technology." />
        <meta name="keywords" content="contact HPTech Solutions, AI services contact, cyber security contact, web development contact" />
        <meta property="og:title" content="Contact Us - HPTech Solutions" />
        <meta property="og:description" content="Need assistance? Reach out to HPTech Solutions for information about our AI, web development, cyber security, and other technology services." />
        <meta property="og:image" content={bgImage} />
    </Helmet>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} />
      </MKBox>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} lg={7}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 0rem)"
            height="calc(90vh - 0rem)"
            borderRadius="xl"
            ml={2}
            mt={2}
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={10}
          md={7}
          lg={6}
          xl={4}
          ml={{ xs: "auto", lg: 6 }}
          mr={{ xs: "auto", lg: 6 }}
        >
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              borderRadius="lg"
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography variant="h3" color="white">
                Contact us
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              <MKTypography variant="body2" color="text" mb={3}>
                For any inquiries, assistance, or feedback, please fill out the
                form below. We'll get back to you as soon as possible.
              </MKTypography>
              <MKBox
                width="100%"
                component="form"
                method="post"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      variant="standard"
                      label="Full Name"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      type="email"
                      variant="standard"
                      label="Email"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MKInput
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      variant="standard"
                      label="What can we help you with?"
                      placeholder="Describe your problem in at least 250 characters"
                      InputLabelProps={{ shrink: true }}
                      multiline
                      fullWidth
                      rows={6}
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container item justifyContent="center" xs={12} mt={5} mb={2}>
                  <MKButton type="submit" variant="gradient" color="info">
                    Send Message
                  </MKButton>
                </Grid>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
      </Grid>

      {/* Additional Company Info */}
      <MKBox p={3} textAlign="center">
        <MKTypography variant="h5" color="info">
          HP TECH SOLUTIONS
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={3}>
        ***************
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={3}>
        support@hptechsolutions.online
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={3}>
        3556 Rapallo Way, Manteca, CA 95337, USA
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={3}>
        Toll-Free: 1-877-590-3845
        </MKTypography>
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>

      {/* Dialog */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>{"Message Status"}</DialogTitle>
        <DialogContent>
          <MKTypography variant="body2">{dialogMessage}</MKTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ContactUs;
